
<template>


<div class="container">
	<div class="row">
		<div class="col-lg-8">
		<h1>Intelligent Apps</h1>
		<small class="text-muted">
		The next generation of applications
		</small>
<p class="lead">
While Intelligent App is not a separate technology, the term is often used as one. Intelligent Apps combine a range of smart technologies that make them the next-generation of applications.

</p>
<p>
Traditionally, computer applications were created as tools enabling us to do the task more efficiently. The new Intelligent Apps are designed to adapt to users lifestyle and habits, learn from their actions, and suggest their activities based on analysis of various future scenarios.
</p>


	<div class="card mx-sm-4 my-4">
		<div class="card-body bg-secondary">
			<h5 class="card-title">Apps that learn from the past to predict the future</h5>
			<p>
				Intelligent Apps combine a range of smart technologies:
				<ul>
					<li>AI</li>
					<li>IoT (Internet of Things)</li>
					<li>Data analytics</li>
					<li>Cloud computing</li>
					<li>and more...</li>
				</ul>
			</p>
		</div>
	</div>




		</div>
		<div class="col-lg-4">


			<div class="card my-5">
				<div class="card-body bg-warning text-white">
					<h5 class="card-title text-white">Cloud - accessible everywhere</h5>
					<p class="card-text">
The on-demand delivery of compute power, database, storage, applications, and other IT resources via the internet with pay-as-you-go pricing.
					</p>
					<a href="#/cloud_computing" class="btn btn-outline-white">More info</a>
				</div>
			</div>

		</div>
	</div>
</div>


</template>

<script>
export default {
	data() {
		return {
			metadata: {
				section: "technology",
				title: "Intelligent Apps"
			}
		}
	},
	methods: {
		loadToParent: function() {
			this.$emit("data-to-parent", this.metadata);
		}
	},
	mounted: function() {
		this.loadToParent();	
	},
}
</script>
